import { Button } from '@hologram-dimension/button';
import { Checkbox } from '@hologram-dimension/checkbox';
import { Link } from '@hologram-dimension/link';
import { Modal } from '@hologram-dimension/modal';
import { useCallback, useState, type FC } from 'react';
import type { CommonModalProps } from '../shared';
import styles from './Apn.module.css';

interface ApnProps extends CommonModalProps {
  onClose: (dontShowModal: boolean) => void;
  apns?: Array<string>;
  isManaged?: boolean;
  showDontShowAgain?: boolean;
}

const Apn: FC<ApnProps> = ({
  onClose,
  apns,
  defaultOpen = false,
  className,
  isManaged = false,
  showDontShowAgain = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = useCallback(() => {
    onClose(dontShowAgain);
  }, [dontShowAgain, onClose]);

  return (
    <Modal
      className={className}
      noContentPadding
      header="Set device APN"
      onClosed={handleClose}
      open={open}
      setOpen={setOpen}
      footer={
        showDontShowAgain && (
          <Checkbox
            label="Don’t show again"
            onChange={(event) => {
              setDontShowAgain((event.currentTarget as any).checked);
            }}
          />
        )
      }
      footerActions={
        <div className={styles.footerActions}>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            variant="secondary"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            Device APN is set
          </Button>
        </div>
      }
    >
      <div className={styles.contentsWrapper}>
        <p className={styles.description}>
          We are now activating your SIM. In order for your device to use data on the Hologram
          network, you will need to set the APN on your device:
        </p>
        <div className={styles.apnAndSettingsWrapper}>
          <div className={styles.apnWrapper}>
            <div className={styles.subHeader}>APN</div>
            <div className={styles.apns}>{apns?.join('/')}</div>
          </div>
          <div className={styles.settingsWrapper}>
            <div className={styles.subHeader}>Settings</div>
            <div className={styles.settings}>No APN username, password, or PIN</div>
          </div>
        </div>
        {isManaged ? (
          <div className={styles.description}>
            If you have worked with our Sales Team for access to custom APNs, some of your SIMs may
            use different APNs. For a walkthrough and more details on APN configuration, please
            check our{' '}
            <Link href="https://support.hologram.io/hc/en-us/articles/360035697853" target="_blank">
              APN guides and documentation
            </Link>
            .
          </div>
        ) : (
          <div className={styles.description}>
            For a walkthrough and more details on APN configuration, please check our{' '}
            <Link href="https://support.hologram.io/hc/en-us/articles/360035697853" target="_blank">
              APN guides and documentation
            </Link>
            .
          </div>
        )}
      </div>
    </Modal>
  );
};
//
export default Apn;
